import Preloader from './modules/preloader';
import './modules/isMobile';
import './modules/ga';
import $ from 'jquery';
import './vendor/jquery.cookiesdirective';


window.addEventListener('load', () => {
    Preloader.hide();
});

	$(document).ready(function(){

		// Cookie setting script wrapper
		var cookieScripts = function () {
			// Internal javascript called
			console.log("Running");
		
			// Loading external javascript file
			$.cookiesDirective.loadScript({
				uri:'external.js',
				appendTo: 'eantics'
			});
		}

    $.cookiesDirective({
      privacyPolicyUri: 'myprivacypolicy.html',
      explicitConsent: false,
      position : 'bottom', 
      backgroundColor: '#e81820',
      linkColor: '#ffffff'
    });
	
	$('ul.tabs li').click(function(e){
    // e.preventDefault();
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');

		if($(this)) {
			$('html, body').stop().animate({
				scrollTop: $("#"+tab_id).offset().top
			}, 'slow');
		}
	})


	$('ul.buttons li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('active');

		$(this).addClass('active');
	})
})
